<template>
  <div class="flex flex-col">
    <div class="flex text-qwellow">{{ $t(header) }}</div>
    <div class="flex text-white text-sm">
      The Qwello Charging Station knows when ther is a car parked in front of it
      and labels it as unavailable to avoid unnecessary annoyances.
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ['header', 'text', 'active'],
};
</script>
